import { Box, Typography } from '@mui/material'
import CoreModal from 'core/CoreModal'
import FailIcon from 'assets/icons-color/fail.png'
import WalletConnector from 'components/WalletConnector'
import { observer } from 'mobx-react-lite'
import { accountStore } from 'stores'

interface Props {
  onClose: () => void
}

const AccessDeniedModal = observer(({ onClose }: Props) => {
  const { eligible } = accountStore

  const Content = (
    <Box
      sx={{
        textAlign: 'center',
      }}
    >
      <img src={FailIcon} alt="FailIcon" width={80} height={80} />
      <Box sx={{ margin: '7px 0px 20px 0px' }}>
        <Typography variant="body1" fontWeight={600}>
          Oh, we’re sorry.
        </Typography>
        <Typography variant="body1" fontWeight={600}>
          You are not on the whitelist.
        </Typography>
      </Box>

      <Box mx="auto" width="100%">
        <WalletConnector fullWidth anotherWallet={!eligible} />
      </Box>
    </Box>
  )

  return <CoreModal open content={Content} onClose={onClose} />
})

export default AccessDeniedModal
